import axios from 'axios';

export const postToLogin = async (requestData) => {
  return await axios.post('/api/accounts/login/', requestData);
};
